import { computed, Injectable, model, signal } from '@angular/core';
import { DataService } from './data.service';
import { UserService } from './user.service';
import { AppstateService } from './appstate.service';
import { DialogService } from './dialog.service';
import { IBudgetantrag } from '../types/IBudgetantrag';
import { Budgetantrag } from '../types/Budgetantrag';
import { IWirtschaftsplan } from '../types/IWirtschaftsplan';

@Injectable({
  providedIn: 'any'
})
export class BudgetDetailsService {

   public allowEdit = computed(() => !this.antrag().freigabeFinal && this.userService.AllowEdit(this.antrag().aktuelleBearbeitung, this.antrag().antragstellerID, this.antrag().pstID, this.antrag().pmID));
   public antrag = signal<IBudgetantrag>(Budgetantrag.default);
   public wirtschaftsplaene = signal<IWirtschaftsplan[]>([]);
   public antragLageplan = signal<File | undefined>(undefined);
   public antragLageplanExtension = computed(() => this.antragLageplan() && this.antrag().lageplanDateiname ? this.antrag().lageplanDateiname!.split('.').pop()?.toLowerCase() : undefined);
   public antragLageplanUrl = computed(() => this.antragLageplan() ? URL.createObjectURL(this.antragLageplan()!) : undefined);
   public isBauControlling = computed<boolean>(() => this.antrag().verwaltungsbereichID == 1);
   public antragChanged = signal<boolean>(false);
   public antragValueChanged = signal("");
   public antragLageplanChanged = signal<boolean>(false);

  
  constructor(private dataService: DataService,
      private userService: UserService,
      private appStateService: AppstateService,
      private dialogService: DialogService) {
    }


 public IsDataValid(): boolean {
    var valid = (!isNaN(this.antrag().wip) && 
                 this.antrag().nr != undefined && 
                 this.antrag().beschreibung != '');
    
    if (this.isBauControlling()) {
      valid = valid && (this.antrag().gesamtflaeche != undefined && 
                        this.antrag().laenge != undefined && 
                        this.antrag().breite != undefined);
      valid = valid && (this.antrag().gesamtflaeche! > 0 || this.antrag().laenge! > 0);                  
    }

    var dateValid = new Date(this.antrag().anfang) <= new Date(this.antrag().ende);
    var dateValidBegruendung = true;
    if (this.antrag().endeChanged) {
      dateValidBegruendung = this.antrag().endeBegruendung != '';
    }

    return valid && dateValid && dateValidBegruendung;
  }

  public DataStateChange() {
    this.antragChanged.set(true);
    this.antragValueChanged.set(Date.now().toString());
  }
 
 
  public ValidateBeforeSave(): boolean {
     if (this.isBauControlling()) {
      if (!this.antrag().beschreibungValidated || !this.antrag().gesamtflaecheValidated || !this.antrag().sonderflaecheValidated) {
        this.dialogService.showInfoDialog('Bitte bestätigen Sie explizit die Angaben für die Felder Beschreibung, Gesamtfläche und Sondierfläche. Klicken Sie dafür auf den Info-Button neben den Feldern oder Bestätigen Sie alle Felder über den Button mit dem Doppelhaken am oberen Rand des Dialoges.', 'Bestätigung der Angaben', 280);
        return false;
      }
      if (this.antrag().gesamtflaeche == 0 && this.antrag().laenge == 0) {
        this.dialogService.showInfoDialog('Bitte geben Sie entweder eine Gesamtfläche oder eine Länge an.', 'Fehlende Angaben', 240);
        return false;
      }
    } else {
      if (!this.antrag().beschreibungValidated) {
        this.dialogService.showInfoDialog('Bitte bestätigen Sie explizit die Angaben für das Feld Beschreibung. Klicken Sie dafür auf den Info-Button neben dem Feld.', 'Bestätigung der Angaben', 240);
        return false;
      }
    }
    if (!this.IsDataValid()) {
      this.dialogService.showErrorDialog('Bitte überprüfen Sie Ihre Eingaben auf Vollständigkeit und Korrektheit.');
      return false;
    }
    return true;
  }

    onWipValueChanged(event: any) {
    this.antrag().nr = this.wirtschaftsplaene().filter(x => x.id == event.value)![0].maxNr;
    this.DataStateChange();
  }

  onCheckedButtonClick(): void {
     if (!this.antrag().beschreibungValidated || !this.antrag().gesamtflaecheValidated || !this.antrag().sonderflaecheValidated) {
      this.antragChanged.set(true);
    }
    this.antrag().beschreibungValidated = true;
    this.antrag().gesamtflaecheValidated = true;
    this.antrag().sonderflaecheValidated = true;
  }

    BeschreibungChange(e: any) {
    this.antrag().beschreibungValidated = false;
    this.antrag().beschreibungChanged = true;
    this.DataStateChange();
  }

  BeschreibungButtonClick(): void {
    this.antrag().beschreibungValidated = !this.antrag().beschreibungValidated;
    this.antragChanged.set(true);
  }

  GesamtflaecheChange(e: any) {
    this.antrag().gesamtflaecheValidated = false;
    this.antrag().gesamtflaecheChanged = true;
    this.DataStateChange();
    this.RefreshLageplanAfterLaengeOderFlaecheChange();
  }

 LaengeChange(e: any) {
    this.DataStateChange();
    this.RefreshLageplanAfterLaengeOderFlaecheChange();
  }

  RefreshLageplanAfterLaengeOderFlaecheChange(): void {
    if (this.antrag().lageplanDateiname && this.antrag().lageplanDateiname != '') {
      this.dialogService.showMessageSheet( 'Der Lageplan wird nach einer Änderung der Länge oder der Gesamtfläche zurückgesetzt. Bitte laden Sie den Lageplan erneut hoch.');
      this.DeleteFileButtonClick();
    }
  }

 
  GesamtflaecheButtonClick(): void {
    this.antrag().gesamtflaecheValidated = !this.antrag().gesamtflaecheValidated;
    this.antragChanged.set(true);
  }

  SondierflaecheChange(e: any) {
    this.antrag().sonderflaecheValidated = false;
    this.antrag().sonderflaecheChanged = true;
    this.DataStateChange();
  }

  SondierflaecheButtonClick(): void {
    this.antrag().sonderflaecheValidated = !this.antrag().sonderflaecheValidated;
    this.antragChanged.set(true);
  }

  UploadFileButtonClick(event: any) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) {
      this.antrag().lageplanDateiname = file.name;
      this.antrag().lageplanDatum = new Date();
      this.antragLageplan.set(file);
      this.antragChanged.set(true);
      this.antragLageplanChanged.set(true);
    }
  }

  DeleteFileButtonClick(): void {
    URL.revokeObjectURL(this.antragLageplanUrl()!);

    this.antrag().lageplanDateiname = "";
    this.antrag().lageplanDatum = undefined;
    this.antragLageplan.set(undefined);
    this.antragChanged.set(true);
    this.antragLageplanChanged.set(true);
  }

  }
